export default __webpack_public_path__ + "static/media/checkIcon.e4664113.svg";